import * as NewsTypes from "./NewsAndMediaTypes";

const initialState = {
  isLoading: false,
  news: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case NewsTypes.IS_NEWS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case NewsTypes.GET_NEWS:
      return {
        ...state,
        news: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
